// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--2Q3RK","title":"header-module--title--2iLmX","pathText":"header-module--pathText--3B94s"};